import { render, staticRenderFns } from "./addLabel.vue?vue&type=template&id=ec946d40&scoped=true"
import script from "./addLabel.vue?vue&type=script&lang=js"
export * from "./addLabel.vue?vue&type=script&lang=js"
import style0 from "./addLabel.vue?vue&type=style&index=0&id=ec946d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec946d40",
  null
  
)

export default component.exports